import { dispatchSlice } from "components/hooks/dispatchSlice";
import { dispatchSliceWithCSRF } from "./dispatchSliceWithCSRF";
import { useSlice } from "components/hooks/useSlice";
import { fetchUserProfile } from "data/slices/userProfile";
import { getMyStatus } from "data/slices/myStatus";

export function useAuthentication() {
  dispatchSlice(getMyStatus);
  dispatchSliceWithCSRF(fetchUserProfile);

  return useSlice("myStatus");
}
